export default  {
    images: ['5.JPG','ashmayu.jpeg','1.JPG','5.JPG','10.JPG','11.JPG','2.JPG','4.JPG','6.JPG','8.JPG'],
    path:"carousal"
};